import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

// Base button with consistent sizing
const BaseButton = styled(Button)(({ theme }) => ({
  height: 48,
  fontSize: 18,
  borderRadius: theme.spacing(2.5),
  textTransform: "none",
  padding: theme.spacing(1.5, 3),
}));

export const StartOverButton = styled(BaseButton)(() => ({
  background: "rgba(255,255,255,0.97)",
  color: "#374151",
  borderColor: "#9CA3AF",
  fontWeight: 500,
  "&:hover": {
    borderColor: "#6B7280",
    backgroundColor: "#F9FAFB",
  },
}));

export const PrimaryActionButton = styled(BaseButton)(() => ({
  background:
    "linear-gradient(89.95deg, #5B47F5 1.57%, #B782FF 50.91%, #D0B1FE 98.39%)",
  color: "white",
  fontWeight: 600,
  minWidth: 100,
  transition: "all 0.3s ease",
  "&:hover": {
    background:
      "linear-gradient(89.95deg, #4A38D9 1.57%, #9F6FE6 50.91%, #C09FED 98.39%)",
    transform: "translateY(-1px)",
    boxShadow: "0 6px 20px rgba(91, 71, 245, 0.4)",
  },
  "&:disabled": {
    background: "#E5E7EB",
    color: "#9CA3AF",
  },
}));
